import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('../views/Index.vue'),
        },
        {
            path: '/:short_code',
            component: () => import('../views/Index.vue'),
        },
        {
            path: '/t/:uid',
            name: 'ticketSms',
            component: () => import('../views/track/Ticket.vue'),
        },
        {
            path: '/tt/:uid',
            name: 'ticketPage',
            component: () => import('../views/track/Ticket.vue'),
        },
        {
            path: '/f/:uid',
            component: () => import('../views/track/Feedback.vue'),
        }
    ]
})

import NProgress from 'nprogress';

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const userLoggedIn = JSON.parse(localStorage.getItem('user'));

    if (to.meta.authRequired && !(userLoggedIn)) {
        if (!userLoggedIn) { localStorage.setItem('user', null) }
        return next('/login');
    }
    if(to.name == "ticketSms") {
        console.log('ergergerg')
        console.log('dd',localStorage.getItem('checkUrl'))
        let test = localStorage.getItem('checkUrl');
        if(test) {
            next('/tt/'+to.params.uid)
        } else {
            localStorage.setItem('checkUrl', true);
            console.log(test ? "true" : "no")
            console.log('ererere : ',"https://easysaffv3.page.link?apn=com.easysaff.liberrex&ibi=com.easysaff.liberrex&link=https%3A%2F%2Feasysaffv3.page.link%2Ftickets%2F"+to.params.uid)
            if( /Android/i.test(navigator.userAgent) ) {
                // easy saff redirect
                window.location.replace("https://easysaffv3.page.link?apn=com.easysaff.liberrex&ibi=com.easysaff.liberrex&link=https%3A%2F%2Feasysaffv3.page.link%2Ftickets%2F"+to.params.uid);

            } else {
                return next('/tt/'+to.params.uid);
            }
        }
        
    }

    next();
})

router.beforeResolve(async (to, from, next) => {
    //const userLoggedIn = JSON.parse(localStorage.getItem('user'));
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
})

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})
export default router